import React from 'react';
import OrderStatusBadge from './OrderStatusBadge';
import { Order } from 'types';
import { useNavigate } from "react-router-dom";

const OrdersTable: React.FC<{ orders: Order[] }> = ({ orders }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile Card View (hidden on md and up) */}
      <div className="md:hidden rounded-lg shadow-sm bg-white divide-y divide-gray-200">
        {orders.map((order) => (
          <div key={order.public_id} className="p-4">
            <div className="space-y-3">
              <div className="flex justify-between items-start">
                <div className="flex gap-1">
                  {/* <div className="text-xs text-gray-500 mt-1">Escrow ID</div> */}
                  <div className="text-sm font-mono text-gray-300">{order.public_id}</div>
                </div>
                <OrderStatusBadge status={order.status} />
              </div>

              <div className="flex justify-between">
                <div className="flex-1">
                  <div className="text-sm text-gray-900">{order.receiver?.full_name || order.receiver_email}</div>
                  <div className="text-xs text-gray-500">User</div>
                </div>
                <div className="flex-1 text-right">
                  <div className="text-sm font-semibold text-gray-900 mt-1">
                    ₦{parseFloat(order.item_price).toLocaleString("en-us", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                  <div className="text-xs text-gray-500">Total</div>
                </div>
              </div>

              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <div className="text-sm text-gray-900">{order.item_name}</div>
                  <div className="text-xs text-gray-500">Item</div>
                </div>
                <button
                  onClick={() => navigate(`/orders/${order.public_id}`)}
                  className="ml-4 bg-gray-100 text-primary-700 text-sm font-medium py-2 px-4 rounded active:scale-95 transition focus:outline-primary-200 focus:ring-2 focus:ring-primary-400 focus:bg-primary-50 cursor-pointer select-none"
                >
                  View
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop Table View (hidden on mobile) */}
      <div className="hidden md:block overflow-x-auto rounded-lg shadow-sm bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Escrow ID</th>
              <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User ID</th>
              <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
              <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-3 lg:px-6 py-3"></th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {orders.map((order) => (
              <tr key={order.public_id} className="hover:bg-gray-50">
                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-sm font-mono">
                  <span className="md:hidden lg:inline">{order.public_id}</span>
                  <span className="hidden md:inline lg:hidden" title={order.public_id}>
                    {order.public_id.substring(0, 8)}...
                  </span>
                </td>
                <td className="px-3 lg:px-6 py-4 text-sm">
                  <div className="truncate max-w-[120px] xl:max-w-none" title={order.receiver?.full_name || order.receiver_email}>
                    {order.receiver?.full_name || order.receiver_email}
                  </div>
                </td>
                <td className="px-3 lg:px-6 py-4 text-sm">
                  <div className="truncate max-w-[100px] lg:max-w-[150px] xl:max-w-none" title={order.item_name}>
                    {order.item_name}
                  </div>
                </td>
                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-sm font-semibold">
                  ₦{parseFloat(order.item_price).toLocaleString("en-us", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                  <OrderStatusBadge status={order.status} />
                </td>
                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                  <button
                    onClick={() => navigate(`/orders/${order.public_id}`)}
                    className="w-full bg-gray-100 text-primary-700 text-sm font-medium py-2 px-3 rounded active:scale-95 transition focus:outline-primary-200 focus:ring-2 focus:ring-primary-400 focus:bg-primary-50 cursor-pointer select-none"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrdersTable;